// Reveals a play button when the browser refuses to autoplay (iOS Low Power Mode, Android Data Saver).
// A scroll event is not a user activation in WebKit, so only a real tap can start the video.
(() => {
  const PAUSED_CHECK_DELAY = 800;

  const init = (root) => {
    if (root.hasAttribute('data-video-play-fallback-ready')) {
      return;
    }
    root.setAttribute('data-video-play-fallback-ready', '');

    const video = root.querySelector('video');
    const playButton = root.querySelector('[data-video-play-fallback-button]');

    if (!video || !playButton) {
      return;
    }

    const showButton = () => {
      playButton.hidden = false;
    };
    const hideButton = () => {
      playButton.hidden = true;
    };

    video.addEventListener('playing', hideButton);
    video.addEventListener('pause', showButton);

    const requestPlay = (event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      const resumed = video.play();

      if (resumed && typeof resumed.catch === 'function') {
        resumed.catch(showButton);
      }
    };

    playButton.addEventListener('click', requestPlay);

    // Tapping anywhere on the frozen poster should start it too, but never swallow a tap meant for
    // the native controls the merchant asked for.
    if (!video.hasAttribute('controls')) {
      root.addEventListener('click', (event) => {
        if (playButton.hidden || event.target.closest('[data-video-play-fallback-button]')) {
          return;
        }

        requestPlay(event);
      });
    }

    // The rejection of play() is how a refused autoplay is detected: there is no API to ask upfront.
    const attempt = video.play();

    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(showButton);
    }

    // Some browsers resolve play() and then leave the video paused, so check the state too.
    window.setTimeout(() => {
      if (video.paused) {
        showButton();
      }
    }, PAUSED_CHECK_DELAY);
  };

  const initAll = () => document.querySelectorAll('[data-video-play-fallback]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
